import utils from '@/services/utils';

export default {
  getStudentInfo(variables = {}) {
    return utils.get('/api/home/book/get/isExistValidityBook', variables);
  },
  getPersonal() {
    return utils.get('/api/home/student/user/get/personalCenter');
  },
  getIntegralDetails(variables = {}) {
    return utils.post('/api/home/student/user/get/integralDetailed', variables);
  },
  getFeedbackType() {
    return utils.get('/api/home/student/user/get/ideaFeedbackType');
  },
  ideaFeedback(variables = {}) {
    return utils.post('/api/home/student/user/create/ideaFeedback', variables);
  },
};
